enum RequestAnswer {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
  UNFIT = 'UNFIT',
  BLOCKED = 'BLOCKED',
  UNKNOWN = 'UNKNOWN',
}

export default RequestAnswer;
